import React, { useEffect, useState } from "react";
import { Container, Form, Input, Label } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import { Table, Row, Col, Card, CardBody } from "reactstrap";

import Pagi2 from "common/utils/Pagi2";
import "../../common/styles/myaccount.css";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import axios from "axios";
import configure from "configure";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import Pagination from "common/utils/Pagination";

function TableContainer({ columns, data, setFilteredData, title }) {
  const [fixedContent, setFixedContent] = useState(false);
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [formPopup, setFormPopup] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [locationFilter, setLocationFilter] = useState("");

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setmodal_fullscreen(false);
    };
    const handleScroll = () => {
      setFixedContent(window.scrollY > 165);
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const safeData = Array.isArray(data) ? data : [];

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data: safeData,
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  useEffect(() => {
    setPageSize(10);
  }, [setPageSize]);

  const handleFilter = () => {
    let filtered = data;
    if (startDate) {
      filtered = filtered.filter(
        (item) => new Date(item.date) >= new Date(startDate)
      );
    }
    if (endDate) {
      filtered = filtered.filter(
        (item) => new Date(item.date) <= new Date(endDate)
      );
    }
    if (locationFilter) {
      filtered = filtered.filter(
        (item) => item.location === parseInt(locationFilter)
      );
    }
    setFilteredData(filtered);
    setFormPopup(false);
  };

  return (
    <div>
      <Row className="m-0 d-flex justify-content-between align-items-center">
        <div className="p-0 col-5">
          <h5 className="text-purple mb-2">{title}</h5>
          {/* <select
            className="form-select mt-1"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select> */}
        </div>
        <div className="p-0 col-4 d-flex justify-content-end align-items-center gap-3">
          <div className="search-box my-xxl-0 d-inline-block">
            <div className="position-relative mt-2">
              <label htmlFor="search-bar-0" className="search-label">
                <span id="search-bar-0-label" className="sr-only">
                  Search this table
                </span>
                <input
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  id="search-bar-0"
                  type="text"
                  className="form-control rounded h-100"
                  placeholder="Search..."
                  value={globalFilter || ""}
                />
              </label>
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered mt-4 w-100" {...getTableProps()}>
          <thead
            className={`${fixedContent ? "fix-header" : ""
              } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setmodal_fullscreen(true);
                        }}
                      ></a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  No data available
                </td>
              </tr>
            ) : (
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr className={`row-hover ${row?.original?.type == "expense" ? 'bg-orange' : ''}`} {...row.getRowProps()} key={i}>
                    {row.cells.map((cell, index) => (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${cell.column.className
                          }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
      {formPopup ? (
        <Draggable>
          <ResizableBox
            style={{
              position: "fixed",
              top: "30%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <Form className="row d-flex justify-content-start align-items-center p-3">
              <div className="col-12">
                <div className="mb-3">
                  <Label htmlFor="start-date">
                    Start Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    id="start-date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <Label htmlFor="end-date">
                    End Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    id="end-date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <Label htmlFor="location-filter">Location</Label>
                  <select
                    className="form-select"
                    id="location-filter"
                    value={locationFilter}
                    onChange={(e) => setLocationFilter(e.target.value)}
                  >
                    <option value="">All Locations</option>
                    <option value="1">India</option>
                    <option value="2">UK</option>
                  </select>
                </div>
                <div className="mt-4 d-flex justify-content-end gap-2">
                  <button
                    className="btn btn-save btn-label"
                    onClick={handleFilter}
                  >
                    <i className="fas fa-filter label-icon"></i> Filter
                  </button>
                  <button
                    className="btn btn-red btn-label"
                    onClick={() => setFormPopup(false)}
                  >
                    <i className="dripicons-cross label-icon"></i> Close
                  </button>
                </div>
              </div>
            </Form>
          </ResizableBox>
        </Draggable>
      ) : null}
    </div>
  );
}

const FinanceIndex = () => {
  document.title = "Bank Account | Zithas Crm";

  const [data, setData] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCommission, setTotalCommission] = useState(0);
  const [totalReceived, setTotalReceived] = useState(0);

  const columns = useMemo(
    () => [
      {
        Header: "Project Name",
        accessor: "name",
        isInfoIcon: true,
        isShortIcon: true,
        className: "project-col",
        Cell: ({ row }) => <div>{row?.original?.name}</div>,
      },
      {
        Header: "Date",
        accessor: "date",
        isInfoIcon: false,
        className: "text-center date-col",
        Cell: ({ row }) => (
          <div>
            {row.original?.date
              ? moment(row.original.date).format("DD-MM-YYYY")
              : "-"}
          </div>
        ),
      },
      {
        Header: "Amount",
        accessor: "paid_amount",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center cost-col",
        Cell: ({ value, row }) => {
          const currencySymbol = row.original.currency_symbol || "₹";
          const values = row?.original?.paid_amount
          return (
            <div className="text-center">
              {values !== null ? parseFloat(values).toLocaleString("en-IN") : "0"}
            </div>
          );
        },
      },
      {
        Header: "TDS",
        accessor: "tds",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center gst-col",
        Cell: ({ value, row }) => {
          const values = row?.original?.type != 'expense' ? parseFloat(value).toLocaleString("en-IN") : '-'
          return (
            <div className="text-center">
              {value !== null ? values : "-"}
            </div>
          );
        },
      },
      {
        Header: "Mode",
        accessor: "paymentMethod",
        isInfoIcon: true,
        isShortIcon: true,
        className: "project-col text-center",
        Cell: ({ value }) => <div>{value}</div>,
      },
    ],
    []
  );

  const columns1 = useMemo(
    () => [

      {
        Header: () => <div style={{ textAlign: "center" }}>Invoice</div>,
        accessor: "tax_inv_no",
        grow: false,
        className: "invoice_box text-centers",
        isInfoIcon: true,
        Cell: ({ value, row }) => (
          <div className="inv_no_width">{value || row.original?.invoice_number || "-"}</div>
        ),
      },
      {
        Header: "Date",
        accessor: "invoice_date",
        isInfoIcon: false,
        className: "text-centers date-col",
        Cell: ({ row }) => (
          <div>
            {row.original?.invoice_date
              ? moment(row.original.invoice_date).format("DD-MM-YYYY")
              : "-"}
          </div>
        ),
      },
      {
        Header: "Customer",
        accessor: "c_company",
        isInfoIcon: true,
        className: "customer-col",
        Cell: ({ value }) => <div>{value || "-"}</div>,
      },
      {
        Header: "Amount",
        accessor: "total",
        isInfoIcon: true,
        className: "text-center amount-col",
        Cell: ({ row }) => (
          <div>
            {row.original?.currency_symbol || "₹"}
            {Number(row.original?.total || 0).toFixed(2)}
          </div>
        ),
      },
      {
        Header: "Commission",
        isInfoIcon: true,
        className: "text-center amount-col",
        Cell: ({ row }) => {
          const items = row.original?.items || [];
          const totalCommission = items.reduce(
            (sum, item) => sum + (Number(item.commission_amount) || 0),
            0
          );

          return (
            <div>
              {row.original?.currency_symbol || "₹"}
              {totalCommission.toFixed(2)}
            </div>
          );
        },
      },
    ],
    []
  );

  const fetchData = async () => {
    try {
      setLoading(true);

      const userData = secureLocalStorage.getItem("User");

      const [financeRes, invoiceRes, zithasRes] = await Promise.all([
        axios.get(`${configure.apiUrl}/finance/${userData.id}`),
        axios.get(`${configure.apiUrl}/introducerInvoice/${userData.id}`),
        axios.get(`${configure.apiUrl}/introducerZithasInvoice/${userData.id}`),
      ]);

      const financeData = financeRes?.data?.finances || [];

      // ✅ Combine both invoice arrays
      const ztplData = invoiceRes?.data?.data || [];
      const zithasData = zithasRes?.data?.data || [];
      const allInvoices = [...ztplData, ...zithasData];

      // ✅ Calculate total commission amount
      const totalCommissionCalc = allInvoices.reduce((sum, invoice) => {
        const items = invoice.items || [];
        const exchangeRate = Number(invoice.exchange_rate) || 1; // Default to 1 if not provided

        const invoiceCommission = items.reduce((itemSum, item) => {
          const commission = Number(item.commission_amount) || 1;
          return itemSum + commission * exchangeRate;
        }, 0);

        return sum + invoiceCommission;
      }, 0);

      // ✅ Calculate total received (paid) amount in INR
      const totalReceivedCalc = financeData.reduce((sum, item) => {
        const totalPaid = parseFloat(item.paid_amount) || 0;
        const exchangeRate = parseFloat(item.currency_rate) || 1;
        const amountInINR =
          item.currency_symbol === "₹" ? totalPaid : totalPaid * exchangeRate;
        return sum + amountInINR;
      }, 0);

      // ✅ Set all states
      setData(financeData);
      setFilteredData(financeData);
      setInvoiceData(allInvoices);
      setTotalCommission(totalCommissionCalc);
      setTotalReceived(totalReceivedCalc);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to load data. Please try again later.");
      setData([]);
      setFilteredData([]);
      setInvoiceData([]);
      setTotalCommission(0);
      setTotalReceived(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content ">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Finance" />

          {/* Tiles Row */}
          {!loading && !error && (
            <Row className="d-flex mb-3 bg-white">
              <div className="d-flex col-md-12 justify-content-start align-items-center gap-3 flex-wrap my-3">
                <div className="col-md-2 d-flex flex-column align-items-center justify-content-center invoice_status text-success rounded text-center py-2">
                  <h6>Total Earnings</h6>
                  <h3>₹ {totalCommission?.toLocaleString("en-IN")}</h3>
                </div>

                <div className="col-md-2 d-flex flex-column align-items-center justify-content-center invoice_status text-primary rounded text-center py-2">
                  <h6>Pending Amount</h6>
                  <h3>
                    ₹{" "}
                    {(Number(totalCommission) - Number(totalReceived))?.toLocaleString("en-IN")}
                  </h3>
                </div>
                <div className="col-md-2 d-flex flex-column align-items-center justify-content-center invoice_status text-danger rounded text-center py-2">
                  <h6>Total Received</h6>
                  <h3>₹ {totalReceived?.toLocaleString("en-IN")}</h3>
                </div>
              </div>
            </Row>
          )}

          {/* Table Section */}
          <Row>
            <Col lg={12} className="p-0">
              {/* <Card>
                <CardBody> */}
              {loading ? (
                <div>Loading...</div>
              ) : error ? (
                <div className="text-danger">
                  {error}{" "}
                  <button onClick={fetchData} className="btn btn-primary">
                    Retry
                  </button>
                </div>
              ) : (
                <div
                  className="d-flex flex-row"
                  style={{ gap: "20px" }} // Adjust gap as needed
                >
                  {/* Invoice Table Box */}
                  <div className="flex-fill" style={{ maxWidth: "48%" }}>
                    <Card>
                      <CardBody>
                        <TableContainer
                          columns={columns1}
                          data={invoiceData}
                          setFilteredData={setFilteredData}
                          title={'My Invoices'}
                        />
                      </CardBody>
                    </Card>
                  </div>

                  {/* Finance Table Box */}
                  <div className="flex-fill" style={{ maxWidth: "48%" }}>
                    <Card>
                      <CardBody>
                        <TableContainer
                          columns={columns}
                          data={filteredData}
                          setFilteredData={setFilteredData}
                          title={'My Earnings'}
                        />
                      </CardBody>
                    </Card>
                  </div>
                </div>
              )}
              {/* </CardBody>
              </Card> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FinanceIndex;
